import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from "../Component/Header";
const VisionMission = () => {
    useEffect(() => {
        document.title = 'Vision and Mission -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  About Us</li>
                 <li>Vision & Mission</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Vision & Mission </h1>
                    </div>
                </div>
                <div className="row">
                <div className="col-lg-12">
                     <div className="qoutes"><p>"To develop our students into responsible, harmonious and integrated individuals through ever evolving curricular and co-curricular activities."</p></div>
                    <h6>How do we realise our Mission</h6> 
                    <p>We encourage learning by exploration. We have audio visual labs for making teaching and learning processes more effective. We use various teaching technologies including information technology.</p>
                    <p>In addition to classroom teaching, we have various avenues of learning such as excursions, camps, dramatics, debates, elocution, quiz, group learning etc. We encourage the students to participate in various clubs like <b> Debating Club, Interact Club, Heritage Club, E.V.S. Club, Quiz Club, Rasayan Club and Consumer Awareness Club.</b></p>
                    <p>The School follows the House System. All students are divided into 5 houses Subroto, Arjan, Pratap, Latif and Katre. This helps the students to strike a fine balance between competition and collaboration. It also provides an opportunity to develop leadership and organising skills among the students. We provide adequate games and sports facilities to students including individual coaching.</p>
                </div>
                </div>
            </div>
            </div>
        
     </>
  )
}

export default VisionMission